import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/left.png';
import _imports_1 from '@/assets/imgs/right.png';
import _imports_2 from '@/assets/advantageImg/advant1.png';
import _imports_3 from '@/assets/advantageImg/advant2.png';
import _imports_4 from '@/assets/advantageImg/advant3.png';
import _imports_5 from '@/assets/advantageImg/advant4.png';
import _imports_6 from '@/assets/advantageImg/advant5.png';
import _imports_7 from '@/assets/advantageImg/advant6.png';

const _withScopeId = n => (_pushScopeId("data-v-5134e3d8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "advantage"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "module-name"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "left-img"
}, null, -1));

const _hoisted_5 = {
  class: "name"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "right-img"
}, null, -1));

const _hoisted_7 = {
  class: "modeList"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "银行一级"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "爆款产品直连银行，没有中间商"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "进件状态反馈及时，多款产品可实时反馈"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "佣金结算准确、权威，不丢单")])], -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "系统强大"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "可支持单户单月百亿级授信"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "程序稳健，弹性部署，支持高并发")])], -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "团队靠谱"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "核心团队是中国SaaS的先行者"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "深耕SaaS十六年"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "集团累计研发投入超亿元")])], -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "iphoneImg"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "真正支持自有品牌"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "品牌自定义、域名自定义 "), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "短信签名自定义、模板自主选")])], -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "实时消息提醒"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, " 支持公众号模板消息，实时通知到经纪人或直客 "), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "支持企业微信消息，实时通知到员工")])], -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "li"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "返佣及时、合规"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "集成上市公司旗下的灵活用工平台"), /*#__PURE__*/_createElementVNode("span", {
  class: "content"
}, "返佣合规可靠，多款产品支持实时返佣")])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($props.name), 1), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_11]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    })]),
    _: 1
  })])]);
}